<script>
import MethodButtonBase from './MethodButtonBase';
import IconMobiilId from '../../assets/svg/mobiil-id.svg';
export default {
  name: 'MobileIdButtonEE',
  components: {
    MethodButtonBase,
    IconMobiilId,
  },
}
</script>

<template>
  <MethodButtonBase>
    <template v-slot:slot1>
      <IconMobiilId :class="$style.icon" />
    </template>
  </MethodButtonBase>
</template>


<style lang="scss" module>
.icon {
  display: block;
  width: 112px;
  height: auto;
}
</style>
